import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ActionButtons = ({ activeTab, handlers, disabled }) => {
  const { t } = useTranslation();
  return (
    <div className="action-buttons">
      {activeTab === 'merge' && (
        <button type="button" className="action-button" onClick={handlers.merge} disabled={disabled}>{t('buttons.merge')}</button>
      )}
      {activeTab === 'split' && (
        <button type="button" className="action-button" onClick={handlers.split} disabled={disabled}>{t('buttons.split')}</button>
      )}
      {activeTab === 'compress' && (
        <button type="button" className="action-button" onClick={handlers.compress} disabled={disabled}>{t('buttons.compress')}</button>
      )}
      {activeTab === 'rotate' && (
        <button type="button" className="action-button" onClick={handlers.rotate} disabled={disabled}>{t('buttons.rotate')}</button>
      )}
      {activeTab === 'convert-images' && (
        <button type="button" className="action-button" onClick={handlers['convert-images']} disabled={disabled}>{t('buttons.convertToImages')}</button>
      )}
      {activeTab === 'password' && (
        <button type="button" className="action-button" onClick={handlers.protect} disabled={disabled}>{t('buttons.addPassword')}</button>
      )}
      {activeTab === 'extract-text' && (
        <button type="button" className="action-button" onClick={handlers['extract-text']} disabled={disabled}>{t('buttons.extractText')}</button>
      )}
      {activeTab === 'watermark' && (
        <button type="button" className="action-button" onClick={handlers.watermark} disabled={disabled}>{t('buttons.addWatermark')}</button>
      )}
      {activeTab === 'pageNumbers' && (
        <button type="button" className="action-button" onClick={handlers['page-numbers']} disabled={disabled}>{t('buttons.addPageNumbers')}</button>
      )}
      {activeTab === 'form' && (
        <button type="button" className="action-button" onClick={handlers['fill-form']} disabled={disabled}>{t('buttons.getFormFields')}</button>
      )}
    </div>
  );
};

ActionButtons.propTypes = {
  activeTab: PropTypes.string.isRequired,
  handlers: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};

export default ActionButtons;
